<template>
  <form
    data-vv-scope="request-password"
    @submit.prevent="action('request-password')"
  >
    <p
      class="text-left"
      id="login-mob-para"
      v-if="!showSuccessMessage"
						data-test="resetPasswrdPara1"
    >
      Please enter your registered Email
    </p>
    <!-- after clicking continue -->
    <div
      class="w-100"
      v-if="showSuccessMessage"
    >
      <p id="reset-password-reset-link"
									data-test="resetPasswrdPara2">
        Check your email
        <strong
          class="forgot-email-id mt-3"
          id="reset-password-reset-link1"
										data-test="resetPasswrdPara3"
        >
          {{email}}
        </strong>
        for reset link.
      </p>
    </div>
    <div class="number-prefix">
      <input
        class="col-12 form-control login-signup-input"
        placeholder="Enter your Email"
        id="reset-password-email"
        v-validate="'required|email'"
        data-ismobileonly="false"
        name="email"
        type="email"
        v-model="email"
        :class="(requestPasswordError &&
        errors.has('request-password.email'))?'is-invalid':''"
								data-test="resetPasswrdEmailInput"
      >
      <div
        class="invalid-feedback"
        v-if="requestPasswordError"
        v-show="errors.has('request-password.email')"
        id="reset-password-email-error"
								data-test="resetPasswrdEmailError"
      >
        {{errors.first('request-password.email')}}
      </div>
    </div><!-- hide after click -->
    <!-- after clicking continue -->
    <button
      class="btn col-12 blue-btn continue-btn mt-2"
      v-loading="loading"
      v-if="showContinueButton"
      id="reset-password-continue-btn"
						data-test="resetPasswrdBtn"
    >
      Continue
    </button><!-- hide after click -->
    <!-- <hr>
	<p>By doing this you cannot use your old passwords for login anymore.</p> -->
  </form>
</template>

<script>
import { authenticationApi } from '@/services/ApiServices/authenticationApi'

export default {
	name: 'RequestResetPasswordForm',
	data () {
		return {
			email: '',
			requestPasswordError: false,
			showSuccessMessage: false,
			showContinueButton: true,
			loading: ''
		}
	},
	mounted () {
		this.$root.$on('ResetPasswordFormClear', () => {
			//
			this.email = ''
			this.showContinueButton = true
			this.requestPasswordError = false
			this.showSuccessMessage = false
		})
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showContinueButton = false
					this.requestPasswordError = false
					this.requestPassword(this.email)
				} else {
					this.showContinueButton = true
					this.requestPasswordError = true
				}
			})
		},
		requestPassword (email) {
			this.loading = authenticationApi.forgotPassword({
				email
			}).then((res) => {
				if (res.status === 200) {
					this.showContinueButton = false
					this.showSuccessMessage = true
					setTimeout(() => {
						// $('#forgotpswd-modal').modal('hide');
						this.$router.push('/')
						this.requestPasswordError = false
						this.showContinueButton = true
						this.showSuccessMessage = false
						this.email = ''
					}, 3000)
				} else {
					this.$toasted.show(' Password reset request failed Please try again later. ', { icon: 'exclamation-circle' })
				}
			}).catch(() => {
				this.requestPasswordError = false
				this.showContinueButton = true
				this.loading = false
			})
		}
	}
}
</script>
